import { useInvalidData } from '../../hooks/useInvalidData'
import { useController } from '../../../../hooks/useController'

import { MultipleDrivers } from './components/MultipleDrivers'
import { SingleDriver } from './components/SingleDriver'

import { ErrorFetchingData } from './components/ErrorFetchingData/ErrorFetchingData'

export function Invalid() {
  const {
    data: { driverIds, validationResult, deletableDriverIds },
  } = useController()

  const invalidData = useInvalidData()

  if (validationResult === undefined && deletableDriverIds.length === 0) {
    // show the user an error message
    return <ErrorFetchingData />
  }

  if (!invalidData || invalidData.quantity === 0) return null

  return driverIds.length === 1 ? (
    <SingleDriver invalidDriverResult={invalidData} />
  ) : (
    <MultipleDrivers invalidDriversResult={invalidData} driverIds={driverIds} />
  )
}
